export const SITE = "https://hyroxninja.com";

export const AUTHOR = {
  id: "daniel-rivas",
  name: "Daniel Rivas",
  credentials: "Founder of Hyrox Ninja · B.S. Exercise Science · DEKA Worlds Qualifier",
  jobTitle: "Founder, Hyrox Ninja",
  bio: "I'm Daniel Rivas, founder of Hyrox Ninja: a Dallas-based hybrid athlete, DEKA Worlds qualifier, and former personal trainer with a degree in Exercise Science. My HYROX journey started with a 1:09:24 singles finish, and I've since recorded personal bests of 58:23 in mixed doubles and 59:51 in men's pro doubles. I created Hyrox Ninja to bring together practical training advice, honest race insights, and a community of athletes pushing to improve. I share what I've learned through training and competition to help you prepare for your first race, chase a new personal best, and enjoy the process along the way.",
  instagram: "https://www.instagram.com/d3rivas_/",
  instagramHandle: "@d3rivas_",
  profile: "https://www.rox-coach.com/seasons/8/races/2026-houston/results/daniel-rivas-desmond-jasper-1",
  profileLabel: "HYROX athlete profile",
  sameAs: [
    "https://www.instagram.com/d3rivas_/",
    "https://www.rox-coach.com/seasons/8/races/2026-houston/results/daniel-rivas-desmond-jasper-1",
    "https://ninjathlete.com",
  ],
};

export const REVIEWER = {
  id: "desmond-jasper",
  name: "Desmond Jasper",
  credentials: "HYROX athlete since 2022 · 1:08:12 Men's Pro Singles",
  jobTitle: "Coach, Hyrox Ninja × Dallas Performance Systems",
  bio: "I'm Desmond \u201CDez\u201D Jasper, a HYROX athlete competing since 2022 across men's doubles, mixed doubles, pro doubles, and pro singles. My personal bests include 1:08:12 in men's pro singles, 59:51 in men's pro doubles with Daniel Rivas, and 1:05:03 in mixed doubles. Every race has taught me something about pacing, teamwork, and pushing through fatigue. Through Hyrox Ninja, I share those lessons to help athletes build confidence, prepare for race day, and keep improving, from their first finish to their next personal best.",
  instagram: "https://www.instagram.com/coachdezjasper/",
  instagramHandle: "@coachdezjasper",
  profile: "https://www.hyresult.com/athlete/desmond-jasper",
  profileLabel: "HyResult athlete profile",
  sameAs: [
    "https://www.hyresult.com/athlete/desmond-jasper",
    "https://www.instagram.com/coachdezjasper/",
    "https://www.rox-coach.com/seasons/8/races/2025-dallas/results/desmond-jasper-1",
  ],
};

export const VENUE = {
  name: "Hyrox Ninja at Dallas Performance Systems",
  street: "2651 Fondren Dr, Ste. B",
  city: "Dallas",
  state: "TX",
  zip: "75206",
  full: "2651 Fondren Dr, Ste. B, Dallas, TX 75206",
};
